import React, { ChangeEvent, useRef } from 'react';
import { useTheme } from '../../hooks/theme';
import { CloseBig, Delete } from '../../icons';
import { Button, IconButton } from '../Button';
import { Paragraph } from '../Typography';

import {
  Container,
  FileControlContainer,
  FileInfoContainer,
  ProgressBar,
  ProgressBarContainer,
} from './Upload.styles';
import { UploadProps } from './Upload.types';

export const Upload: React.FC<UploadProps> = ({
  uploadProgress = 1,
  selectText = 'Anexar documento',
  file,
  onChange,
  error,
  style,
  noCancel,
  ...props
}) => {
  const theme = useTheme();

  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = e.target.files[0];
    onChange(fileUploaded);
  };

  const handleCancel = () => {
    hiddenFileInput.current.value = '';
    onChange(null);
  };

  return (
    <Container style={style} {...props}>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        data-testid={'upload-input'}
      />
      {file ? (
        <FileControlContainer>
          {uploadProgress >= 1 || error ? (
            <IconButton
              data-testid={`${file.name}-delete`}
              type="button"
              variant="text"
              icon={Delete}
              iconColor={
                error ? theme.colors.support.vanderleia[100] : theme.colors.neutral.grey[100]
              }
              iconSize={24}
              style={{ height: 24, width: 24, marginRight: 8, boxSizing: 'content-box' }}
              onClick={handleCancel}
            />
          ) : (
            !noCancel && (
              <IconButton
                data-testid={`${file.name}-cancel`}
                type="button"
                variant="text"
                icon={CloseBig}
                iconColor={theme.colors.neutral.grey[100]}
                iconSize={12}
                style={{ height: 24, width: 24, marginRight: 8, boxSizing: 'content-box' }}
                onClick={handleCancel}
              />
            )
          )}
          <FileInfoContainer>
            <p>{file.name}</p>
            {error ? (
              <Paragraph
                variant="p2"
                style={{
                  fontSize: 14,
                  color: theme.colors.support.vanderleia[100],
                }}
              >
                Erro ao carregar documento
              </Paragraph>
            ) : (
              uploadProgress !== 1 && (
                <ProgressBarContainer>
                  <ProgressBar data-testid="progressbar" progress={uploadProgress} />
                </ProgressBarContainer>
              )
            )}
          </FileInfoContainer>
        </FileControlContainer>
      ) : (
        <Button
          style={{ width: 'auto', height: 'auto', fontSize: 16 }}
          type="button"
          variant="text"
          onClick={handleClick}
        >
          {selectText}
        </Button>
      )}
    </Container>
  );
};
